<template>
  <div
    class="x-input-group x-input-group-neutral x-w-full x-rounded-full x-border-neutral-10 !x-outline-0"
  >
    <SearchButton
      v-if="isDesktopOrGreater || !x.query.searchBox"
      class="x-input-group-button-ghost x-p-0"
    >
      <SearchIcon class="x-icon-lg x-font-bold x-text-lead-75" />
    </SearchButton>
    <SearchInput
      ref="searchInputRef"
      :autofocus="false"
      :placeholder="$t('searchBox.placeholder')"
      :instant="true"
      class="x-font-alternative placeholder:x-font-alternative desktop:!x-pl-8"
    />

    <ClearSearchInput
      v-if="isDesktopOrGreater && x.query.searchBox"
      class="x-input-group-button x-input-group-button-rectangle"
    >
      {{ $t('searchBox.clear') }}
    </ClearSearchInput>

    <ClearSearchInput
      v-if="!isDesktopOrGreater && x.query.searchBox"
      class="x-input-group-button-ghost"
    >
      <CrossTinyIcon class="x-icon-lg" />
    </ClearSearchInput>
  </div>
</template>

<script setup lang="ts">
import { CrossTinyIcon, SearchIcon, use$x } from '@empathyco/x-components'
import { ClearSearchInput, SearchButton, SearchInput } from '@empathyco/x-components/search-box'
import { ref } from 'vue'
import { useDevice } from '../composables/use-device.composable'

const { isDesktopOrGreater } = useDevice()
const x = use$x()
const searchInputRef = ref<InstanceType<typeof SearchInput>>(null as any)
</script>
